<template>
  <v-expansion-panels :value="0" flat>
    <v-expansion-panel>
      <v-expansion-panel-header class="py-0 pl-1 align-start text-selection">
        <div  @click="handleHeaderClick">
          <v-container class="py-0">
            <v-row>
              <v-col>
                <h3>Guia de pagamento</h3>
              </v-col>
            </v-row>

            <v-row align="start">
              <v-col class="py-0" cols="6">
                <div>BENEFICIÁRIO</div>
                <div v-if="pagamentoGuia.numeroCarteira" class="font-weight-bold">{{ pagamentoGuia.numeroCarteira }}</div>
                <div v-if="pagamentoGuia.numeroCarteira" class="font-weight-bold mt-1">{{ pagamentoGuia.nomeBeneficiario }}</div>
                <v-chip v-else-if="pagamentoGuia.isBaixa" small>Guia de baixa</v-chip>
                <v-chip v-else-if="isUsuarioTradimus">Indisponível</v-chip>
                <span v-else>-</span>
              </v-col>
              <v-col class="py-0">
                <div>SENHA</div>
                <div v-if="pagamentoGuia.senha" class="font-weight-bold">{{ pagamentoGuia.senha | formatNullValue }}</div>
                <v-chip v-else-if="pagamentoGuia.isBaixa" small>Guia de baixa</v-chip>
                <v-chip v-else-if="isUsuarioTradimus">Indisponível</v-chip>
                <span v-else>-</span>
              </v-col>
              <v-col class="py-0">
                 <div>GUIA OPERADORA</div>
                 <div v-if="pagamentoGuia.numeroGuiaOperadora" class="font-weight-bold">{{ pagamentoGuia.numeroGuiaOperadora | formatNullValue }}</div>
                 <v-chip v-else-if="pagamentoGuia.isBaixa" small>Guia de baixa</v-chip>
                 <v-chip v-else-if="isUsuarioTradimus">Indisponível</v-chip>
                 <span v-else>-</span>
               </v-col>
            </v-row>
          </v-container>
        </div>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-container class="py-5 px-4">
          <v-row>
            <v-col class="pt-2 pb-0">
              <div>CONCILIAÇÃO</div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6" class="py-0">
              <percent-bar-group :progress-bars="valorPercentBar" />
            </v-col>
            <v-col cols="6" class="py-0">
              <percent-bar-group :progress-bars="itemPercentBar" />
            </v-col>
          </v-row>

          <v-row>
            <v-col class="pt-2">
              <div>VALOR INFORMADO</div>
              <div class="font-weight-bold">{{ pagamentoGuia.valorInformado | currency }}</div>
            </v-col>
            <v-col class="pt-2">
              <div>VALOR PAGO</div>
              <div class="font-weight-bold success--text">{{ pagamentoGuia.valorPago | currency }}</div>
            </v-col>
            <v-col class="pt-2">
              <div>VALOR GLOSADO</div>
              <div class="font-weight-bold red--text">{{ pagamentoGuia.valorGlosado | currency }}</div>
            </v-col>
          </v-row>
        </v-container>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<style scoped>
.v-expansion-panel-content::v-deep .v-expansion-panel-content__wrap {
  padding: 0 !important;
}

.text-selection {
  user-select: text;
}
</style>

<script>
import { formatCurrency, getItemPercentMessages, getValorPercentMessages, sessionStorageClient } from '../../../libs'
import PercentBarGroup from '../../common/PercentBarGroup.vue'

export default {
  components: {
    PercentBarGroup
  },
  props: {
    pagamentoGuia: { type: Object, required: true }
  },
  methods: {
    handleHeaderClick (event) {
      if (window?.getSelection()?.toString()) {
        event.stopPropagation()
        return
      }
    }
  },
  computed: {
    valorPercentMessages () {
      return getValorPercentMessages(this.pagamentoGuia.valorTotalItens, this.pagamentoGuia.valorItensConciliacaoAutomatica, this.pagamentoGuia.valorItensConciliacaoManual)
    },
    itemPercentMessages () {
      return getItemPercentMessages(this.pagamentoGuia.quantidadeItens, this.pagamentoGuia.quantidadeItensConciliacaoAutomatica, this.pagamentoGuia.quantidadeItensConciliacaoManual)
    },
    valorPercentBar () {
      return [
        {
          label: 'Valor',
          total: this.pagamentoGuia.percentualConciliadoValor,
          automatica: this.pagamentoGuia.percentualConciliadoValorAutomatico,
          manual: this.pagamentoGuia.percentualConciliadoValorManual,
          textAutomatica: this.valorPercentMessages.textAutomatica,
          textManual: this.valorPercentMessages.textManual,
          textRestante: this.valorPercentMessages.textRestante
        }
      ]
    },
    itemPercentBar () {
      return [
        {
          label: 'Itens',
          total: this.pagamentoGuia.percentualConciliadoQuantidade,
          automatica: this.pagamentoGuia.percentualConciliadoQuantidadeAutomatico,
          manual: this.pagamentoGuia.percentualConciliadoQuantidadeManual,
          textAutomatica: this.itemPercentMessages.textAutomatica,
          textManual: this.itemPercentMessages.textManual,
          textRestante: this.itemPercentMessages.textRestante
        }
      ]
    },
    isUsuarioTradimus () {
      const usuarioTradimus = sessionStorageClient.getItem('userData')?.['UsuarioTradimus']
      return usuarioTradimus
    }
  },
  filters: {
    currency (value) {
      return formatCurrency(value)
    }
  }
}
</script>
